import {
  defaultPhoneNumber,
  dtdDirectNumber,
  paidSEM,
  paidSEMNumber,
} from '../../constants/phoneSalesBannerConstants'

const showPhoneSalesBanner = (
  phoneBookInfo,
  phonePlacementsEnabled = false,
  { displayErrorPage = false } = {}
) => {
  if (displayErrorPage) {
    return false
  }

  const { phoneNumber } = phoneBookInfo
  if (phoneNumber && phonePlacementsEnabled) {
    return true
  }
  return false
}

const getPhoneNumber = (isMobileDevice, searchRefId) => {
  if (paidSEM.indexOf(searchRefId) > -1) {
    return isMobileDevice ? paidSEMNumber.mobile : paidSEMNumber.desktop
  }

  if (searchRefId === 'DTDIRECT') {
    return isMobileDevice ? dtdDirectNumber.mobile : dtdDirectNumber.desktop
  }

  return isMobileDevice ? defaultPhoneNumber.mobile : defaultPhoneNumber.desktop
}

export { getPhoneNumber, showPhoneSalesBanner }
